module.exports = __webpack_public_path__ + "img/carousel1.1bd32fde.png";